import React from 'react';

import { LinkMenuItem } from '@atlaskit/side-nav-items/link-menu-item';

import { SPACE_SUGGESTIONS } from '@confluence/named-routes/entry-points/routes.ts';

import type { ContentIntelligenceSidebarSectionProps } from './ContentIntelligenceSidebarSection.tsx';

/**
 * What the sidebar shows while the section's chunk loads: the same link the trigger will become, so
 * the rows below it do not shift when the section arrives.
 *
 * Kept free of the section's own imports so it adds nothing to the sidebar's bundle.
 */
export const ContentIntelligenceSidebarSectionPlaceholder = ({
	spaceKey,
	children,
	elemBefore,
	elemAfter,
}: ContentIntelligenceSidebarSectionProps): React.JSX.Element => (
	<LinkMenuItem
		href={SPACE_SUGGESTIONS.toUrl({ spaceKey })}
		elemBefore={elemBefore}
		elemAfter={elemAfter}
		testId="space-suggestions-link-placeholder"
	>
		{children}
	</LinkMenuItem>
);
